export default "__VITE_ASSET__BQOuRNE6__"